<template>
  <fullscreen-modal :visible.sync="visible" :title="'查看报单'" :close-on-click-modal="false" @close="handleClose">
    <div class="view-declaration-modal">
      <el-form :model="info" ref="infoForm" label-width="120px">
        <el-card shadow="hover" class="card">
          <div slot="header" class="clearfix">
            <span>商户报单信息:</span>
          </div>
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="报单商家名称:">
                <span>{{ info.shopName }}</span>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="报单商家电话:">
                <span>{{ info.shopMobile }}</span>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="现场对接人姓名:">
                <span>{{ info.region }}</span>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="现场对接人电话:">
                <span>{{ info.contactMobile }}</span>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="业务员:">
                <span>{{ info.salesperson }}</span>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="进场时间:">
                <span>{{ info.entranceTime ? new Date(info.entranceTime).toLocaleDateString() : '-' }}</span>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="付款人电话">
                <span>{{ info.customMobile }}</span>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="付款人姓名">
                <span>{{ info.customName }}</span>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="装饰公司:">
                <span>{{ info.introducer }}</span>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="备注:">
                <span>{{ info.remarks }}</span>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="出货形式:">
                <span>{{ info.appointmentType }}</span>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="户型:">
                <span>{{ info.houseType }}</span>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="施工地址(区/县)">
                <span>{{ info.customAddress }}</span>
              </el-form-item>
            </el-col>
            <!-- 施工工艺 -->
            <el-col :span="12">
              <el-form-item label="施工工艺:">
                <span>{{ info.installationForm }}</span>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <div class="btn-group">
              <el-button type="danger" size="small" @click="handleClose"
                icon="el-icon-circle-close-outline">关闭</el-button>
            </div>
          </el-row>
          <!--  <el-form-item label="面积明细:">
            <el-table :data="info.areaConfig" style="width: 100%" border>
              <el-table-column prop="name" label="名称" width="180">
                <template slot-scope="scope">
                  <span>{{ scope.row.name }}</span>
                </template>
</el-table-column>
<el-table-column prop="length" label="长度(m)" width="300">
  <template slot-scope="scope">
                  <span>{{ scope.row.length }}</span>
                </template>
</el-table-column>
<el-table-column prop="width" label="宽度(m)" width="300">
  <template slot-scope="scope">
                  <span>{{ scope.row.width }}</span>
                </template>
</el-table-column>
<el-table-column prop="area" label="面积(㎡)" width="300">
  <template slot-scope="scope">
                  <span>{{ scope.row.area }}</span<>
                </template>
</el-table-column>
<el-table-column prop="productName" label="商品名称" width="300">
  <template slot-scope="scope">
                  <span v-if="scope.row.productName">{{ scope.row.productName }}</span>
                </template>
</el-table-column>
</el-table>
</el-form-item>

<el-form-item label="商品列表:">
  <el-table :data="selectedGoods" style="width: 100%" border>
    <el-table-column prop="goodsName" label="商品名称" />
    <el-table-column prop="num" label="数量" />
  </el-table>
</el-form-item> -->
        </el-card>
      </el-form>
    </div>
  </fullscreen-modal>
</template>

<script>
import {
  getMerchantOrder,
  getAreaConfigById,
  getGoodList,
} from "@/api/work/pipeline/merchants";
import FullscreenModal from "./fullscreen-modal.vue";

export default {
  name: "ViewDeclarationModal",
  components: {
    FullscreenModal,
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    id: {
      type: [String, Number],
      default: "",
    },
  },
  data() {
    return {
      info: {
        region: "",
        customAddress: "",
        houseType: "",
        installationType: "",
        installationForm: "",
        remove: "",
        area: "",
        payType: "",
        measureTime: null,
        declarationDate: null,
        entranceTime: null,
        salesperson: "",
        customName: "",
        customMobile: "",
        remarks: "",
        introducer: "",
      },
      selectedGoods: [],
    };
  },
  watch: {
    visible(val) {
      if (val && this.id) {
        this.loadData();
      }
    },
  },
  methods: {
    loadData() {
      this.resetData();
      this.getMerchantOrderData();
    },
    resetData() {
      this.info = {
        region: "",
        customAddress: "",
        houseType: "",
        installationType: "",
        installationForm: "",
        remove: "",
        area: "",
        payType: "",
        measureTime: null,
        declarationDate: null,
        entranceTime: null,
        salesperson: "",
        customName: "",
        customMobile: "",
        remarks: "",
        introducer: "",
      };
      this.selectedGoods = [];
    },
    getMerchantOrderData() {
      getMerchantOrder(this.id).then((res) => {
        if (res.code === "200") {
          const data = JSON.parse(res.data).rows[0];
          this.info = {
            ...this.info,
            ...data,
          };
          if (data.list && data.list.length > 0) {
            this.processSelectedGoods(data.list);
          } else {
            getGoodList(this.id).then((res) => {
              if (res.code === "200") {
                let selectedGoods = JSON.parse(res.data);
                selectedGoods.forEach((goods) => {
                  if (goods.goodsId) {
                    let existingGoods = this.selectedGoods.find(
                      (g) => g.goodsId === goods.goodsId
                    );
                    if (existingGoods) {
                      existingGoods.num += goods.num;
                    } else {
                      this.selectedGoods.push(goods);
                    }
                  }
                });
              }
            });
          }
          this.getAreaConfig();
        }
      });
    },
    getAreaConfig() {
      getAreaConfigById(this.id).then((res) => {
        if (res.code == "200") {
          const areaData = JSON.parse(res.data);
          this.info.areaConfig = areaData || [];
        }
      });
    },
    processSelectedGoods(selectedGoods) {
      selectedGoods.forEach((g) => {
        this.selectedGoods.push({
          goodsId: g.goodsId,
          goodsName: g.goodsName,
          num: g.num,
        });
      });
    },
    handleClose() {
      this.$emit("update:visible", false);
      this.$emit("close");
    },
  },
};
</script>

<style lang="scss" scoped>
.view-declaration-modal {
  min-height: 100%;
}

.card {
  margin-bottom: 20px;
}

.clearfix {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.btn-group {
  display: flex;
  justify-content: center;
  margin-top: 20px;
  gap: 10px;
}
</style>
